export default function HoverLinksPortfolio(props) {
    return (
        <div className="hoverPortfolio">
            <article>
                <p>{props.title}</p>
            </article>
            <article>
            <a href={props.git} target="_blank" ><i class="fa-brands fa-github"></i></a>
            <a href={props.linke} target="_blank" ><i class="fa-solid fa-globe"></i></a>
            </article>
        </div>
    );
}